var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DinTypography } from '../styled';
import Nps from './Nps';
import { PhotoProvider, PhotoView } from "../../../../components/react-photo-view";
import dayjs from 'dayjs';
import { Box, Paper, Typography } from 'fbm-ui';
import { Stack } from 'fbm-ui/lib/mui';
export var QUESTION_TYPE;
(function (QUESTION_TYPE) {
    QUESTION_TYPE[QUESTION_TYPE["IMAGE_UPLOAD"] = 1] = "IMAGE_UPLOAD";
    QUESTION_TYPE[QUESTION_TYPE["ESSAY_QUESTION"] = 2] = "ESSAY_QUESTION";
    QUESTION_TYPE[QUESTION_TYPE["RADIO"] = 3] = "RADIO";
    QUESTION_TYPE[QUESTION_TYPE["CHECKBOX"] = 3.2] = "CHECKBOX";
    QUESTION_TYPE[QUESTION_TYPE["TIME"] = 4] = "TIME";
    QUESTION_TYPE[QUESTION_TYPE["SCHOOL"] = 7] = "SCHOOL";
    QUESTION_TYPE[QUESTION_TYPE["FILL_BLANKS"] = 8] = "FILL_BLANKS";
    QUESTION_TYPE[QUESTION_TYPE["NPS"] = 9] = "NPS";
})(QUESTION_TYPE || (QUESTION_TYPE = {}));
var Image = function (answer) {
    var _a, _b, _c;
    return (_jsx(PhotoProvider, __assign({ maskOpacity: 0.5 }, { children: (_c = (_b = (_a = answer.formAnswer) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.filter(function (v) { return v; })) === null || _c === void 0 ? void 0 : _c.map(function (url) { return (_jsx(PhotoView, __assign({ src: url }, { children: _jsx("img", { src: url, alt: url, width: 48, height: 32 }) }), url)); }) })));
};
var fillBlanks = function (answer) { var _a, _b; return _jsx(Typography, __assign({ variant: "body2" }, { children: (_b = (_a = answer === null || answer === void 0 ? void 0 : answer.formAnswer) === null || _a === void 0 ? void 0 : _a.answer) === null || _b === void 0 ? void 0 : _b.join(',') })); };
var Choice = function (answer) {
    var _a, _b;
    var keys = ((_a = answer === null || answer === void 0 ? void 0 : answer.formAnswer) === null || _a === void 0 ? void 0 : _a.choiceOptions) || [];
    var options = ((_b = answer === null || answer === void 0 ? void 0 : answer.formItemOption) === null || _b === void 0 ? void 0 : _b.alternatives) || [];
    return options
        .filter(function (v) { return keys.includes(v.key); })
        .map(function (v) { return v.value; })
        .join(',');
};
var template = (_a = {},
    _a[QUESTION_TYPE.RADIO] = Choice,
    _a[QUESTION_TYPE.CHECKBOX] = Choice,
    _a[QUESTION_TYPE.ESSAY_QUESTION] = function (answer) { var _a; return (_a = answer === null || answer === void 0 ? void 0 : answer.formAnswer) === null || _a === void 0 ? void 0 : _a.answer; },
    _a[QUESTION_TYPE.TIME] = function (answer) {
        var _a, _b, _c;
        return ((_a = answer === null || answer === void 0 ? void 0 : answer.formAnswer) === null || _a === void 0 ? void 0 : _a.dateTime) &&
            !isNaN((_b = answer === null || answer === void 0 ? void 0 : answer.formAnswer) === null || _b === void 0 ? void 0 : _b.dateTime) &&
            dayjs(Number((_c = answer === null || answer === void 0 ? void 0 : answer.formAnswer) === null || _c === void 0 ? void 0 : _c.dateTime) * 1000).format('YYYY年MM月DD日');
    },
    _a[QUESTION_TYPE.SCHOOL] = function (answer) { var _a; return (_a = answer === null || answer === void 0 ? void 0 : answer.formAnswer) === null || _a === void 0 ? void 0 : _a.answer; },
    _a[QUESTION_TYPE.FILL_BLANKS] = fillBlanks,
    _a[QUESTION_TYPE.NPS] = Nps,
    _a[QUESTION_TYPE.IMAGE_UPLOAD] = Image,
    _a);
var Form = function (_a) {
    var answers = _a.answers, _b = _a.customProcessName, customProcessName = _b === void 0 ? '资料收集' : _b;
    return (_jsxs(Box, __assign({ component: Paper, m: 3, pt: 2 }, { children: [_jsxs(Box, __assign({ display: "flex", sx: {
                    height: 40,
                    pl: 3,
                    pr: 4,
                    color: '#009D56',
                    background: 'url(//webcdn.fbmms.cn/assets/yt-b/yf2BqqIlr8Xtb8N2o44t1) no-repeat center center',
                    backgroundSize: 'contain',
                    width: 'fit-content',
                    overflow: 'hidden',
                    mb: 2,
                    alignItems: 'center',
                } }, { children: [_jsx("img", { className: "MuiSvgIcon-root", src: "//webcdn.fbmms.cn/assets/Vj2m/QMPCkdJ4uQYCS0ovOtKJ5", alt: "", width: 20, height: 20 }), _jsx(DinTypography, __assign({ variant: "h6", sx: {
                            ml: 1,
                            color: '#009D56',
                            lineHeight: '24px',
                            width: 'auto',
                        } }, { children: customProcessName }))] })), _jsxs(Stack, __assign({ p: 3, pt: 0 }, { children: [_jsxs(Stack, __assign({ direction: "row", sx: {
                            background: '#E5FDE6',
                            color: '#009D56',
                            borderRadius: 20,
                            py: 1,
                            px: 2,
                        }, justifyContent: "flex-start" }, { children: [_jsx(Typography, __assign({ variant: "body2", color: "inherit", sx: { width: 52 } }, { children: "\u5E8F\u53F7" })), _jsx(Typography, __assign({ variant: "body2", flex: 1, color: "inherit", sx: { width: 479 }, mr: 7 }, { children: "\u9898\u76EE" })), _jsx(Typography, __assign({ variant: "body2", flex: 1, color: "inherit", sx: { width: 200 } }, { children: "\u56DE\u7B54" }))] })), _jsx(Stack, __assign({ sx: {
                            background: 'rgba(249, 250, 249, 1)',
                            mt: 1,
                        } }, { children: answers === null || answers === void 0 ? void 0 : answers.map(function (answer, index) {
                            var _a;
                            return (_jsxs(_Fragment, { children: [_jsxs(Stack, __assign({ direction: "row", sx: {
                                            py: 1,
                                            px: 2,
                                        } }, { children: [_jsx(Typography, __assign({ variant: "body2", sx: { width: 52 } }, { children: index + 1 })), _jsx(Typography, __assign({ variant: "body2", flex: 1, mr: 7 }, { children: answer.formTypeKey })), _jsx(Typography, __assign({ variant: "body2", flex: 1 }, { children: (_a = template[answer.formTypeId]) === null || _a === void 0 ? void 0 : _a.call(template, answer) }))] }), index), _jsx(Box, { sx: { background: '#fff', height: 2, mx: 1 } })] }));
                        }) }))] }))] })));
};
export default Form;
